var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subApp"},[_c('div',{staticClass:"app-container"},[_c('router-view')],1),(_vm.$route.path=='/index'||_vm.$route.path=='/Message'||_vm.$route.path=='/send'||_vm.$route.path=='/pay')?_c('tabbar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }